import { Card, CardContent, CardHeader, CardTitle } from '@1trading/react';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import {
  AXIS_TICK,
  CHART_SERIES_COLORS,
  CURSOR_FILL,
  formatEuroTooltip,
  GRID_STROKE,
  renderLegendLabel,
  TOOLTIP_CONTENT_STYLE,
  TOOLTIP_ITEM_STYLE,
} from '@/components/charts/recharts-theme';
import type { FeesChartRow } from '@/services/api/risk-fees';
import { formatEuros } from '@/utils/format';

const CHART_HEIGHT = 400;
const Y_AXIS_WIDTH = 96;

interface FeesChartProps {
  data: FeesChartRow[];
  /** Base currency codes in key-discovery order — series and colors follow this */
  series: string[];
}

/** Stacked bar of collected fees (EUR) per UTC day, one segment per currency. */
export const FeesChart = ({ data, series }: FeesChartProps) => (
  <Card>
    <CardHeader>
      <CardTitle>Collected Fees</CardTitle>
    </CardHeader>
    <CardContent>
      <ResponsiveContainer height={CHART_HEIGHT} width="100%">
        <BarChart data={data}>
          <CartesianGrid stroke={GRID_STROKE} strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="date" tick={AXIS_TICK} />
          <YAxis tick={AXIS_TICK} tickFormatter={formatEuros} width={Y_AXIS_WIDTH} />
          <Tooltip contentStyle={TOOLTIP_CONTENT_STYLE} cursor={CURSOR_FILL} formatter={formatEuroTooltip} itemStyle={TOOLTIP_ITEM_STYLE} />
          <Legend formatter={renderLegendLabel} />
          {series.map((currency, index) => (
            <Bar dataKey={currency} fill={CHART_SERIES_COLORS[index % CHART_SERIES_COLORS.length]} key={currency} stackId="fees" />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </CardContent>
  </Card>
);
FeesChart.displayName = 'FeesChart';
